let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("glWzP"), load("c6MKV"), load("aZinD"), load("joJy8"), load("aHE9G"), load("cyGuT")]).then(() => parcelRequire('biiXa'));